// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.d-flex[data-v-7b439aac] {\r\n  display: flex;\n}\n.justify-content-center[data-v-7b439aac] {\r\n  justify-content: center;\n}\n[dir] .mb-1[data-v-7b439aac] {\r\n  margin-bottom: 1rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
